import { useMemo } from 'react'

import { useBrandsQueries } from 'hooks-queries/brands'

import { GET_BRANDS_CATEGORIES_LOG } from './consts'

export function useBrandsCategories() {
  const { data } = useBrandsQueries({
    errorLog: GET_BRANDS_CATEGORIES_LOG,
    queryName: 'getListBrandSOAOnCategoryPaginated',
  })

  const brands = useMemo(() => {
    const brandsData = data?.listBrandSOAOnCategoryPaginated?.data || []
    const brandsList = brandsData.map(brand => brand?.brand)

    return brandsList
  }, [data?.listBrandSOAOnCategoryPaginated?.data])

  const categories = useMemo(() => {
    const brandCategories = data?.listBrandSOAOnCategoryPaginated?.data || []
    const categoriesMap = new Map<string, { id: string; name: string }>()

    brandCategories.forEach(brand => {
      categoriesMap.set(brand?.category?.id, brand?.category)
    })

    return Array.from(categoriesMap.values())
  }, [data?.listBrandSOAOnCategoryPaginated?.data])

  return {
    brands,
    categories,
  }
}
